export const PublishConst = {
	NOT_SENT: "NOT_SENT",
	SENT: "SENT",
	PUBLISHED: "PUBLISHED",
	CONFIRMED: "CONFIRMED",
	ERROR: "ERROR",
	UNAVAILABLE: "UNAVAILABLE",
	UE_VALIDATION_ERROR: "UE_VALIDATION_ERROR",
	NOT_PUBLISHED: "NOT_PUBLISHED",
}
